import RestrictedPropertyIcon from '../components/common/RestrictedPropertyIcon';
import DSFieldRecord from '../filterQueryFormat/DSFieldRecord/DSFieldRecord';
import { resolveIsUngated } from './UserInfoHelper';
import { isFieldRestricted } from './fieldLevelPermissions';
import { getIconComponent } from './getIconComponent';
import { jsx as _jsx } from "react/jsx-runtime";
const groupFieldOptions = fieldOptions => {
  return fieldOptions.reduce((acc, fieldOption) => {
    if (!DSFieldRecord.isDSFieldRecord(fieldOption)) {
      acc.push({
        type: 'GROUP',
        displayName: fieldOption.get('displayName'),
        options: []
      });
      return acc;
    }
    const option = {
      type: 'OPTION',
      property: fieldOption
    };
    const previousOption = acc[acc.length - 1];
    if ((previousOption === null || previousOption === void 0 ? void 0 : previousOption.type) === 'GROUP') {
      previousOption.options.push(option);
      return acc;
    } else {
      acc.push(option);
      return acc;
    }
  }, []);
};
const formatFieldOptionToSelectOption = filterFamily => ({
  property
}) => {
  const IconComponent = getIconComponent(property, resolveIsUngated(), filterFamily);
  return {
    disabled: property.disabled,
    text: property.displayName || property.name,
    value: property.name,
    icon: IconComponent,
    iconColor: 'icon-primary-disabled',
    badge: isFieldRestricted(property.accessLevel) ? /*#__PURE__*/_jsx(RestrictedPropertyIcon, {}) : undefined
  };
};
export const formatFieldOptionsToSelectOptions = (fieldOptions, filterFamily) => {
  const groupedFieldOptions = groupFieldOptions(fieldOptions);
  return groupedFieldOptions.map(propertyOrGroup => {
    if (propertyOrGroup.type === 'GROUP') {
      return {
        text: propertyOrGroup.displayName,
        options: propertyOrGroup.options.map(formatFieldOptionToSelectOption(filterFamily))
      };
    } else {
      return formatFieldOptionToSelectOption(filterFamily)(propertyOrGroup);
    }
  });
};